var giphy_viewer_default = {
  "giphyWrapper": "XDzaC",
  "giphy_player": "DS-pN",
  "playIcon": "EcpH-",
  "gifRatio": "CC9ga"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
